import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-vendor-pre-estimation-report',
  templateUrl: './vendor-pre-estimation-report.component.html',
  styleUrls: ['./vendor-pre-estimation-report.component.scss']
})
export class VendorPreEstimationReportComponent implements OnInit {

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;

  ngOnInit() {
    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Month Wise', routerLink: `/${parentRoute}/report/pre-estimation/month-wise`},
          { label: 'District Wise', routerLink: `/${parentRoute}/report/pre-estimation/district-wise` },
          { label: 'User Wise', routerLink: `/${parentRoute}/report/pre-estimation/user-wise` },
          { label: 'Vendor Wise',routerLink: `/${parentRoute}/report/pre-estimation/vendor-wise` },
          
        ];
      }
      );
  }

}
